"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundThemeProvider = exports.MoodThemeProvider = exports.SecondaryThemeProvider = exports.PrimaryThemeProvider = exports.InnerThemeProvider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var ThemeProvider_1 = require("@cvent/carina/components/ThemeProvider/ThemeProvider");
var BlockContext_1 = require("./BlockContext");
var BlocksTypography_1 = require("./BlocksTypography");
var useBuildThemes_1 = __importDefault(require("../hooks/useBuildThemes"));
var BlockWithTypography_1 = __importDefault(require("./BlockWithTypography"));
var useTheme_1 = __importDefault(require("../hooks/useTheme"));
/**
 * For use outside of a stack of blocks
 */
function BlockThemeProvider(_a) {
    var primary = _a.primary, secondary = _a.secondary, background = _a.background, mood = _a.mood, children = _a.children, _b = _a.blockColorKey, blockColorKey = _b === void 0 ? 'mood' : _b, _c = _a.safeMode, safeMode = _c === void 0 ? true : _c, _d = _a.preferFormula, preferFormula = _d === void 0 ? null : _d, headingFont = _a.headingFont, bodyFont = _a.bodyFont, typographyClassName = _a.typographyClassName, divProps = __rest(_a, ["primary", "secondary", "background", "mood", "children", "blockColorKey", "safeMode", "preferFormula", "headingFont", "bodyFont", "typographyClassName"]);
    var _e = (0, useBuildThemes_1.default)({
        primary: primary,
        secondary: secondary,
        background: background,
        mood: mood,
        safeMode: safeMode,
        preferFormula: preferFormula,
        bodyFont: bodyFont,
        headingFont: headingFont
    }), themes = _e.themes, themeColors = _e.themeColors;
    if (!themes) {
        return null;
    }
    var theme = themes[blockColorKey];
    var blockColor = themeColors[blockColorKey];
    var context = {
        index: 0,
        count: 1,
        blockColorKey: blockColorKey,
        blockColor: blockColor
    };
    return ((0, jsx_runtime_1.jsxs)(ThemeProvider_1.ThemeProvider, __assign({ theme: theme }, { children: [(0, jsx_runtime_1.jsx)(BlocksTypography_1.BlocksTypographyVariables, { headingFont: headingFont, bodyFont: bodyFont, typographyClassName: typographyClassName }), (0, jsx_runtime_1.jsx)(BlockContext_1.BlockProvider, __assign({ value: context }, { children: (0, jsx_runtime_1.jsx)(BlockWithTypography_1.default, __assign({}, divProps, { children: children })) }))] })));
}
exports.default = BlockThemeProvider;
/**
 * Convenience provider for rendering BlockThemeProvider within the context of another BlockThemeProvider.
 */
function InnerThemeProvider(props) {
    var palette = (0, useTheme_1.default)().palette;
    return (0, jsx_runtime_1.jsx)(BlockThemeProvider, __assign({}, palette, props));
}
exports.InnerThemeProvider = InnerThemeProvider;
/**
 * Convenience provider for rendering primary BlockThemeProvider within the context of another BlockThemeProvider.
 */
function PrimaryThemeProvider(props) {
    return (0, jsx_runtime_1.jsx)(InnerThemeProvider, __assign({ blockColorKey: "primary" }, props));
}
exports.PrimaryThemeProvider = PrimaryThemeProvider;
/**
 * Convenience provider for rendering secondary BlockThemeProvider within the context of another BlockThemeProvider.
 */
function SecondaryThemeProvider(props) {
    return (0, jsx_runtime_1.jsx)(InnerThemeProvider, __assign({ blockColorKey: "secondary" }, props));
}
exports.SecondaryThemeProvider = SecondaryThemeProvider;
/**
 * Convenience provider for rendering mood BlockThemeProvider within the context of another BlockThemeProvider.
 */
function MoodThemeProvider(props) {
    return (0, jsx_runtime_1.jsx)(InnerThemeProvider, __assign({ blockColorKey: "mood" }, props));
}
exports.MoodThemeProvider = MoodThemeProvider;
/**
 * Convenience provider for rendering background BlockThemeProvider within the context of another BlockThemeProvider.
 */
function BackgroundThemeProvider(props) {
    return (0, jsx_runtime_1.jsx)(InnerThemeProvider, __assign({ blockColorKey: "background" }, props));
}
exports.BackgroundThemeProvider = BackgroundThemeProvider;
//# sourceMappingURL=BlockThemeProvider.js.map